import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import { getPathname, hasDirectImageExtension, isImageContentType } from '../utils/contentType';

export class DirectImageResolver implements MediaResolver {
  name = 'DirectImageResolver';

  async canResolve(context: ResolverContext): Promise<boolean> {
    const { url } = context.input;
    const pathname = getPathname(url);

    if (hasDirectImageExtension(pathname) || hasDirectImageExtension(url)) {
      return true;
    }

    try {
      const content = await context.fetchContent(url);

      return isImageContentType(content.contentType);
    } catch {
      return hasDirectImageExtension(pathname);
    }
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    const { url, thumbnailUrl, title, description } = context.input;

    return {
      mediaType: 'image',
      playerType: 'html5',
      playbackUrl: url,
      thumbnailUrl: thumbnailUrl ?? url,
      title: title ?? undefined,
      description: description ?? undefined,
      resolved: true,
      resolverName: this.name,
    };
  }
}
